document.documentElement.classList.remove('no-js');

// Discourage casual image saving without interfering with links or controls.
document.addEventListener('contextmenu', (event) => {
  if (event.target.closest?.('img')) event.preventDefault();
});
document.addEventListener('dragstart', (event) => {
  if (event.target.closest?.('img')) event.preventDefault();
});

const portalHeaderDrawer = (root = document) => {
  const drawer = root.querySelector?.('[data-header-drawer]') || document.querySelector('[data-header-drawer]');
  if (drawer && drawer.parentElement !== document.body) document.body.appendChild(drawer);
  return drawer;
};
portalHeaderDrawer();

const FYNCHIE_SECTION_KEY = 'fynchie-shop-section';
const validShopSection = (value, drawer) => {
  if (!['all', 'interiors', 'apparel', 'objects', 'journal', 'gifts', 'beauty', 'travel'].includes(value)) return false;
  if (value === 'objects' && drawer?.dataset.objectsEnabled !== 'true') return false;
  if (value === 'kids' && drawer?.dataset.kidsEnabled !== 'true') return false;
  if (value === 'gifts' && drawer?.dataset.giftsEnabled !== 'true') return false;
  if (value === 'journal' && drawer?.dataset.journalEnabled !== 'true') return false;
  if (value === 'gifts' && drawer?.dataset.giftsEnabled !== 'true') return false;
  if (value === 'beauty' && drawer?.dataset.beautyEnabled !== 'true') return false;
  if (value === 'travel' && drawer?.dataset.travelEnabled !== 'true') return false;
  return Boolean(drawer?.querySelector(`[data-drawer-mode="${value}"]`));
};
const applyDrawerMode = (drawer, requestedMode, remember = false) => {
  if (!drawer) return;
  const fallback = validShopSection(drawer.dataset.fallbackShopSection, drawer) ? drawer.dataset.fallbackShopSection : 'interiors';
  const mode = validShopSection(requestedMode, drawer) ? requestedMode : fallback;
  drawer.querySelectorAll('[data-drawer-switch]').forEach((button) => {
    const active = button.dataset.drawerSwitch === mode;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
  });
  drawer.querySelectorAll('[data-drawer-mode]').forEach((panel) => {
    const active = panel.dataset.drawerMode === mode;
    panel.hidden = !active;
    panel.classList.toggle('is-active', active);
  });
  drawer.querySelectorAll('[data-drawer-view]').forEach((view) => {
    const root = view.dataset.drawerView === `${mode}-root`;
    view.hidden = !root;
    view.classList.toggle('is-active', root);
    view.classList.remove('is-parent');
  });
  drawer.classList.remove('has-expanded-view');
  if (remember) {
    try { window.localStorage.setItem(FYNCHIE_SECTION_KEY, mode); } catch (error) {}
  }
};
const contextualDrawerMode = (drawer) => {
  return validShopSection('all', drawer) ? 'all' : (drawer?.dataset.fallbackShopSection || 'interiors');
};
const initializeContextualDrawer = (drawer = document.querySelector('[data-header-drawer]')) => {
  if (!drawer) return;
  const contextualMode = contextualDrawerMode(drawer);
  applyDrawerMode(drawer, contextualMode, Boolean(drawer.dataset.currentShopSection));
};
initializeContextualDrawer();

const siteHeader = document.querySelector('[data-site-header]');
const headerGroup = siteHeader?.closest('.shopify-section-group-header-group') || siteHeader?.parentElement;
const updateHeaderHeight = () => {
  if (!headerGroup) return;
  document.documentElement.style.setProperty('--header-group-height', `${headerGroup.offsetHeight}px`);
};
const updateHeaderState = () => {
  if (!siteHeader) return;
  const isScrolled = window.scrollY > 10;
  siteHeader.classList.toggle('is-scrolled', isScrolled);
  headerGroup?.classList.toggle('is-scrolled', isScrolled);
  window.requestAnimationFrame(updateHeaderHeight);
};
updateHeaderState();
window.addEventListener('scroll', updateHeaderState, { passive: true });
window.addEventListener('resize', updateHeaderHeight, { passive: true });
window.addEventListener('load', updateHeaderHeight);

const initializeProductImageViewer = (root = document) => {
  const viewer = document.querySelector('[data-product-image-viewer]');
  const viewerImage = viewer?.querySelector('[data-product-image-viewer-image]');
  if (!viewer || !viewerImage || viewer.dataset.ready === 'true') return;
  viewer.dataset.ready = 'true';
  let returnFocus = null;
  const close = () => {
    viewer.hidden = true;
    viewer.setAttribute('aria-hidden', 'true');
    viewerImage.removeAttribute('src');
    document.documentElement.classList.remove('product-image-viewer-open');
    returnFocus?.focus?.();
  };
  const open = (trigger) => {
    returnFocus = trigger;
    viewerImage.src = trigger.dataset.zoomSrc;
    viewerImage.alt = trigger.dataset.zoomAlt || '';
    viewer.hidden = false;
    viewer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('product-image-viewer-open');
    viewer.querySelector('.product-image-viewer__close')?.focus();
  };
  document.querySelectorAll('[data-product-image-zoom]').forEach((trigger) => {
    trigger.addEventListener('click', () => open(trigger));
    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); open(trigger); }
    });
  });
  viewer.querySelectorAll('[data-product-image-viewer-close]').forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !viewer.hidden) close();
  });
};
initializeProductImageViewer();
document.addEventListener('shopify:section:load', () => initializeProductImageViewer());

const installVideoControls = (root = document) => {
  root.querySelectorAll('video[autoplay]').forEach((video) => {
    if (video.closest('.video-control-wrap')) return;
    const wrap = document.createElement('span');
    wrap.className = 'video-control-wrap';
    video.parentNode.insertBefore(wrap, video);
    wrap.appendChild(video);
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'video-toggle';
    button.dataset.videoToggle = '';
    button.setAttribute('aria-label', 'Pause video');
    button.innerHTML = '<span aria-hidden="true"></span>';
    wrap.appendChild(button);
    const sync = () => {
      const playing = !video.paused && !video.ended;
      button.classList.toggle('is-paused', !playing);
      button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    };
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    sync();
  });
};
installVideoControls();
document.addEventListener('shopify:section:load', (event) => installVideoControls(event.target));
document.addEventListener('shopify:section:load', (event) => portalHeaderDrawer(event.target));

// FYNCHIE smart-search vocabulary: broadens common customer language without changing product titles.
const fynchieSearchAliases = {
  dress: 'dress OR dresses OR gown OR gowns',
  dresses: 'dress OR dresses OR gown OR gowns',
  gown: 'dress OR dresses OR gown OR gowns',
  gowns: 'dress OR dresses OR gown OR gowns',
  trouser: 'trouser OR trousers OR pant OR pants',
  trousers: 'trouser OR trousers OR pant OR pants',
  pant: 'trouser OR trousers OR pant OR pants',
  pants: 'trouser OR trousers OR pant OR pants',
  blouse: 'blouse OR shirt OR top',
  shirt: 'shirt OR blouse OR top',
  top: 'top OR blouse OR shirt',
  robe: 'robe OR kimono OR kaftan OR caftan',
  kimono: 'kimono OR robe OR kaftan OR caftan',
  kaftan: 'kaftan OR caftan OR robe OR kimono',
  caftan: 'caftan OR kaftan OR robe OR kimono'
};
const fynchieExpandedSearchQuery = (query) => {
  const normalized = String(query || '').trim().toLowerCase();
  return fynchieSearchAliases[normalized] || String(query || '').trim();
};

const buildFynchieSearchUrl = (query, originalQuery = query) => {
  const searchParams = new URLSearchParams({ type: 'product', q: query });
  searchParams.set('options[prefix]', 'last');
  searchParams.set('options[unavailable_products]', 'show');
  if (query !== originalQuery) searchParams.set('fynchie_q', originalQuery);
  return `${window.Shopify?.routes?.root || '/'}search?${searchParams.toString()}`;
};

const renderFynchieSearchPreview = (container, searchDocument, viewAllUrl) => {
  const inner = document.createElement('div');
  inner.className = 'fynchie-search__predictive-inner';
  const productCards = [...searchDocument.querySelectorAll('[data-search-section] .product-grid > .product-card')].slice(0, 8);

  if (productCards.length === 0) {
    const empty = document.createElement('p');
    empty.className = 'fynchie-search__predictive-empty';
    empty.textContent = 'No matching products';
    inner.append(empty);
    container.replaceChildren(inner);
    return;
  }

  const label = document.createElement('p');
  label.className = 'eyebrow';
  label.textContent = 'Products';

  const list = document.createElement('ul');
  list.className = 'fynchie-search__predictive-list';
  list.setAttribute('role', 'listbox');

  productCards.forEach((card) => {
    const item = document.createElement('li');
    item.setAttribute('role', 'option');

    const link = document.createElement('a');
    const sourceLink = card.matches('a[href]') ? card : card.querySelector('a[href]');
    const sourceHref = sourceLink?.getAttribute('href') || sourceLink?.href;
    if (!sourceHref || sourceHref === 'undefined' || sourceHref.endsWith('/undefined')) return;
    link.href = sourceHref;

    const image = card.querySelector('img');
    if (image) link.append(image.cloneNode(true));

    const text = document.createElement('span');
    const title = document.createElement('strong');
    title.textContent = card.querySelector('.product-card__title')?.textContent?.trim() || '';
    const price = document.createElement('small');
    price.textContent = card.querySelector('.price')?.textContent?.trim() || '';
    text.append(title, price);
    link.append(text);
    item.append(link);
    list.append(item);
  });

  const viewAll = document.createElement('a');
  viewAll.className = 'fynchie-search__view-all';
  viewAll.href = viewAllUrl;
  viewAll.textContent = 'View all results';
  inner.append(label, list, viewAll);
  container.replaceChildren(inner);
};

const initializePredictiveSearch = (root = document) => {
  root.querySelectorAll?.('[data-search-section]').forEach((section) => {
    if (section.dataset.predictiveReady === 'true') return;
    section.dataset.predictiveReady = 'true';
    const form = section.querySelector('[data-predictive-search-form]');
    const input = section.querySelector('[data-predictive-search-input]');
    const results = section.querySelector('[data-predictive-search-results]');
    const clear = section.querySelector('[data-search-clear]');
    if (!form || !input || !results) return;
    let controller;
    let timer;
    const closeResults = () => {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    };
    const loadResults = async () => {
      const query = input.value.trim();
      clear.hidden = query.length === 0;
      if (query.length < 2) { closeResults(); return; }
      controller?.abort();
      controller = new AbortController();
      const expandedQuery = fynchieExpandedSearchQuery(query);
      const activeController = controller;
      const url = buildFynchieSearchUrl(expandedQuery, query);
      try {
        const response = await fetch(url, { signal: activeController.signal, cache: 'no-store', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
        const responseText = await response.text();
        if (activeController.signal.aborted || input.value.trim() !== query) return;
        const searchDocument = new DOMParser().parseFromString(responseText, 'text/html');
        renderFynchieSearchPreview(results, searchDocument, url);
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      } catch (error) {
        if (error.name !== 'AbortError') closeResults();
      }
    };
    form.addEventListener('submit', () => {
      const originalQuery = input.value.trim();
      const expandedQuery = fynchieExpandedSearchQuery(originalQuery);
      if (expandedQuery !== originalQuery) {
        let original = form.querySelector('input[name="fynchie_q"]');
        if (!original) { original = document.createElement('input'); original.type = 'hidden'; original.name = 'fynchie_q'; form.appendChild(original); }
        original.value = originalQuery;
        input.value = expandedQuery;
      }
    });
    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(loadResults, 180);
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeResults();
    });
    clear?.addEventListener('click', () => {
      input.value = '';
      clear.hidden = true;
      closeResults();
      input.focus();
    });
    document.addEventListener('click', (event) => {
      if (!section.contains(event.target)) closeResults();
    });
  });
};
initializePredictiveSearch();
document.addEventListener('shopify:section:load', (event) => initializePredictiveSearch(event.target));

const restoreFynchieSearchTerm = (scope = document) => {
  const params = new URLSearchParams(window.location.search);
  const original = params.get('fynchie_q');
  if (!original) return;
  scope.querySelectorAll?.('[data-search-visible-term]').forEach((input) => { input.value = original; });
  scope.querySelectorAll?.('[data-search-results-summary]').forEach((summary) => {
    const count = summary.dataset.resultsCount || '';
    const label = summary.dataset.resultsLabel || 'results for';
    summary.textContent = `${count} ${label} “${original}”`;
  });
};
restoreFynchieSearchTerm();
document.addEventListener('shopify:section:load', (event) => restoreFynchieSearchTerm(event.target));

const statusRegion = document.getElementById('FynchieStatus');
const announce = (message) => {
  if (!statusRegion) return;
  statusRegion.textContent = '';
  window.setTimeout(() => { statusRegion.textContent = message; }, 50);
};

document.addEventListener('click', async (event) => {
  const share = event.target.closest('[data-share]');
  if (share) {
    const data = { title: share.dataset.title, url: share.dataset.url };
    if (navigator.share) {
      await navigator.share(data).catch(() => {});
    } else {
      await navigator.clipboard.writeText(data.url);
      announce('Product link copied.');
    }
  }
  const copy = event.target.closest('[data-copy-link]');
  if (copy) {
    await navigator.clipboard.writeText(copy.dataset.copyLink);
    announce('Product link copied.');
  }
  const toggle = event.target.closest('[data-menu-toggle]');
  const close = event.target.closest('[data-menu-close]');
  if (toggle) {
    const drawer = portalHeaderDrawer();
    if (!drawer) return;
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    drawer.hidden = expanded;
    document.body.classList.toggle('menu-open', !expanded);
    if (!expanded) {
      applyDrawerMode(drawer, 'all');
      drawer.classList.remove('has-expanded-view');
      const closeButton = drawer.querySelector('.header-drawer__close');
      window.requestAnimationFrame(() => closeButton?.focus());
    }
  }
  if (close) {
    const drawer = document.querySelector('[data-header-drawer]');
    const toggleButton = document.querySelector('[data-menu-toggle]');
    drawer.hidden = true;
    drawer.classList.remove('has-expanded-view');
    toggleButton?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
    toggleButton?.focus();
  }
  const drawerSwitch = event.target.closest('[data-drawer-switch]');
  if (drawerSwitch) {
    const drawer = drawerSwitch.closest('[data-header-drawer]');
    const mode = drawerSwitch.dataset.drawerSwitch;
    applyDrawerMode(drawer, mode, true);
  }
  const levelOpen = event.target.closest('[data-drawer-open]');
  const levelReturn = event.target.closest('[data-drawer-return]');
  if (levelOpen || levelReturn) {
    const drawer = event.target.closest('[data-header-drawer]');
    const modePanel = event.target.closest('[data-drawer-mode]');
    const targetId = levelOpen?.dataset.drawerOpen || levelReturn?.dataset.drawerReturn;
    const currentView = event.target.closest('[data-drawer-view]');
    const targetView = modePanel?.querySelector(`[data-drawer-view="${CSS.escape(targetId)}"]`);
    if (levelOpen && targetView) {
      const hasEditorialContent = Boolean(targetView.querySelector('.header-drawer__visual-card'));
      const landingLink = targetView.querySelector('.header-drawer__panel-cta[href]');
      if (!hasEditorialContent && landingLink?.href) {
        window.location.href = landingLink.href;
        return;
      }
    }
    if (targetView) {
      modePanel?.querySelectorAll('[data-drawer-view]').forEach((view) => {
        view.hidden = true;
        view.classList.remove('is-active', 'is-parent');
      });

      const isRoot = targetId.endsWith('-root');
      let parentView = null;
      if (!isRoot) {
        const parentId = targetView.dataset.parentView;
        parentView = parentId
          ? modePanel?.querySelector(`[data-drawer-view="${CSS.escape(parentId)}"]`)
          : currentView;
      }

      if (parentView && parentView !== targetView) {
        parentView.hidden = false;
        parentView.classList.add('is-parent');
      }
      targetView.hidden = false;
      window.requestAnimationFrame(() => targetView.classList.add('is-active'));
      targetView.querySelector('button, a')?.focus({ preventScroll: true });
      modePanel.querySelector('.header-drawer__scroll')?.scrollTo({ top: 0, behavior: 'smooth' });
      drawer?.classList.toggle('has-expanded-view', !isRoot);
    }
  }
  const videoToggle = event.target.closest('[data-video-toggle]');
  if (videoToggle) {
    event.preventDefault();
    event.stopPropagation();
    const video = videoToggle.parentElement?.querySelector('video');
    if (!video) return;
    if (video.paused) video.play().catch(() => {});
    else video.pause();
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const drawer = document.querySelector('[data-header-drawer]');
  if (!drawer || drawer.hidden) return;
  drawer.hidden = true;
  drawer.classList.remove('has-expanded-view');
  document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('menu-open');
});

document.querySelectorAll('[data-product-form]').forEach((form) => {
  const select = form.querySelector('[name="id"]');
  const price = form.querySelector('[data-product-price]');
  const button = form.querySelector('[name="add"]');
  if (!select) return;
  select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    if (price) price.textContent = option.dataset.price || '';
    if (button) {
      button.disabled = option.dataset.available !== 'true';
      button.textContent = option.dataset.available === 'true' ? 'Add to bag' : 'Sold out';
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  });
});

const fynchieFavoriteKey = (handle, color = '') => {
  const normalized = String(color || '').trim().toLowerCase();
  return `fynchie-favorite:${handle}:${normalized ? `color:${encodeURIComponent(normalized)}` : 'product'}`;
};
const fynchieFavoriteRead = (handle, color = '') => {
  try { const value = window.localStorage.getItem(fynchieFavoriteKey(handle, color)); return Boolean(value && value !== 'false'); } catch (error) { return false; }
};
const fynchieFavoriteWrite = (handle, color, variantId, active) => {
  const key = fynchieFavoriteKey(handle, color);
  try {
    if (!active) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, JSON.stringify({ handle, color: color || '', variantId: variantId ? String(variantId) : '' }));
  } catch (error) {}
};
const fynchieRenderFavoriteButton = (button, active) => {
  if (!button) return;
  button.classList.toggle('is-active', active);
  button.setAttribute('aria-pressed', String(active));
  const icon = button.querySelector('[aria-hidden="true"]');
  if (icon) icon.textContent = active ? '♥' : '♡';
};

const initializeUniversalProducts = (root = document) => {
  root.querySelectorAll?.('[data-universal-product]').forEach((productRoot) => {
    if (productRoot.dataset.universalReady === 'true') return;
    productRoot.dataset.universalReady = 'true';
    const form = productRoot.querySelector('[data-product-form]');
    const variantInput = form?.querySelector('[data-variant-input]');
    const price = form?.querySelector('[data-product-price]');
    const addButton = form?.querySelector('[name="add"]');
    const selectedLabel = form?.querySelector('[data-selected-variant]');
    const purchaseNote = form?.querySelector('[data-purchase-note]');
    const variantsData = (() => {
      try { return JSON.parse(productRoot.querySelector('[data-product-variants-json]')?.textContent || '[]'); }
      catch (error) { return []; }
    })();
    const favorite = productRoot.querySelector('[data-product-favorite]');
    const favoriteSelection = () => {
      const currentId = String(variantInput?.value || '');
      const currentVariant = variantsData.find((variant) => String(variant.id) === currentId) || variantsData[0];
      const colorPosition = Number.parseInt(productRoot.dataset.colorOptionPosition || '0', 10);
      const color = colorPosition > 0 ? (currentVariant?.options?.[colorPosition - 1] || '') : '';
      let representative = currentVariant;
      if (color && colorPosition > 0) {
        representative = variantsData.find((variant) => variant.options?.[colorPosition - 1] === color && variant.featured_media) || variantsData.find((variant) => variant.options?.[colorPosition - 1] === color) || currentVariant;
      }
      return { handle: productRoot.dataset.productHandle || '', color, variantId: representative?.id || currentId };
    };
    const syncProductFavorite = () => {
      if (!favorite) return;
      const selection = favoriteSelection();
      fynchieRenderFavoriteButton(favorite, fynchieFavoriteRead(selection.handle, selection.color));
    };
    const drawer = productRoot.querySelector('[data-variant-drawer]');
    const panel = drawer?.querySelector('.variant-drawer__panel');
    const triggers = [...productRoot.querySelectorAll('[data-variant-drawer-open]')];
    const trigger = triggers[0];
    let lastTrigger = null;
    const closeDrawer = () => {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      triggers.forEach((item) => item.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('variant-drawer-open');
      window.setTimeout(() => { drawer.hidden = true; }, 320);
      lastTrigger?.focus({ preventScroll: true });
    };
    const openDrawer = () => {
      if (!drawer) return;
      lastTrigger = lastTrigger || trigger;
      drawer.hidden = false;
      document.body.classList.add('variant-drawer-open');
      triggers.forEach((item) => item.setAttribute('aria-expanded', 'true'));
      window.requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        drawer.querySelector('.variant-drawer__option:not([aria-disabled="true"])')?.focus({ preventScroll: true });
      });
    };
    triggers.forEach((item) => item.addEventListener('click', () => { lastTrigger = item; openDrawer(); }));
    drawer?.querySelectorAll('[data-variant-drawer-close]').forEach((button) => button.addEventListener('click', closeDrawer));
    productRoot.querySelectorAll('[data-variant-option]').forEach((option) => option.addEventListener('click', () => {
      if (option.dataset.variantAvailable !== 'true') return;
      productRoot.querySelectorAll('[data-variant-option]').forEach((item) => item.classList.toggle('is-selected', item.dataset.variantId === option.dataset.variantId));
      if (variantInput) variantInput.value = option.dataset.variantId;
      if (selectedLabel) selectedLabel.textContent = option.dataset.variantTitle;
      if (price) price.textContent = option.dataset.variantPrice;
      if (addButton) {
        addButton.disabled = false;
        const mode = option.dataset.purchaseMode || 'standard';
        addButton.textContent = mode === 'special' ? (addButton.dataset.specialOrderLabel || 'Special Order') : mode === 'preorder' ? (addButton.dataset.preorderLabel || 'Pre-order') : (addButton.dataset.addLabel || 'Add to Cart');
        if (purchaseNote) {
          let note = '';
          if (mode === 'special') note = `Special order: ${option.dataset.leadTime || '3–4 weeks'}`;
          if (mode === 'preorder') note = option.dataset.preorderDate ? `Pre-order: Expected to ship ${option.dataset.preorderDate}` : 'Pre-order';
          purchaseNote.textContent = note;
          purchaseNote.hidden = !note;
        }
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.dataset.variantId);
      window.history.replaceState({}, '', url);
      syncProductFavorite();
      closeDrawer();
    }));

    productRoot.querySelectorAll('[data-product-colorway]').forEach((colorway) => colorway.addEventListener('click', (event) => {
      if (colorway.classList.contains('is-unavailable')) return;
      event.preventDefault();
      const colorLabel = colorway.dataset.colorLabel || '';
      const currentVariant = variantsData.find((variant) => String(variant.id) === String(variantInput?.value));
      let nextVariant = variantsData.find((variant) => variant.options?.includes(colorLabel) && currentVariant?.options?.every((value) => value === colorLabel || variant.options.includes(value)));
      if (!nextVariant) nextVariant = variantsData.find((variant) => String(variant.id) === String(colorway.dataset.variantId));
      if (!nextVariant) return;
      if (variantInput) variantInput.value = nextVariant.id;
      if (price && colorway.dataset.variantPrice) price.textContent = colorway.dataset.variantPrice;
      if (addButton) {
        addButton.disabled = colorway.dataset.variantAvailable !== 'true';
        addButton.textContent = addButton.disabled ? (addButton.dataset.soldOutLabel || 'Sold out') : (addButton.dataset.addLabel || 'Add to Cart');
      }
      productRoot.querySelectorAll('[data-product-colorway]').forEach((item) => {
        const isCurrent = item === colorway;
        item.classList.toggle('is-current', isCurrent);
        item.setAttribute('aria-checked', isCurrent ? 'true' : 'false');
      });
      const picker = colorway.closest('.product-colorways--tiered');
      const colorwayGroup = colorway.closest('.product-colorways__group');
      picker?.querySelectorAll('.product-colorways__group').forEach((group) => {
        const label = group.querySelector('.product-colorways__label');
        if (!label) return;
        label.querySelector('.product-colorways__separator')?.remove();
        label.querySelector('.product-colorways__selected-name')?.remove();
        if (group !== colorwayGroup) return;
        const separator = document.createElement('span');
        separator.className = 'product-colorways__separator';
        separator.textContent = ' — ';
        const selectedName = document.createElement('span');
        selectedName.className = 'product-colorways__selected-name';
        selectedName.textContent = colorLabel;
        label.append(separator, selectedName);
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', nextVariant.id);
      window.history.replaceState({}, '', url);
      productRoot.querySelector('.product-gallery')?.fynchieSelectColor?.(colorLabel, nextVariant.featured_media?.id);
      syncProductFavorite();
    }));

    const shareButton = productRoot.querySelector('[data-product-share]');
    if (shareButton) {
      shareButton.addEventListener('click', async () => {
        const shareData = { title: shareButton.dataset.shareTitle || document.title, url: shareButton.dataset.shareUrl || window.location.href };
        if (navigator.share) {
          try { await navigator.share(shareData); } catch (error) { if (error?.name !== 'AbortError') console.warn('Share unavailable', error); }
          return;
        }
        try {
          await navigator.clipboard.writeText(shareData.url);
          const label = shareButton.querySelector('span');
          if (label) { const original = label.textContent; label.textContent = 'Link copied'; window.setTimeout(() => { label.textContent = original; }, 1600); }
        } catch (error) { window.prompt('Copy this link:', shareData.url); }
      });
    }

    if (favorite) {
      syncProductFavorite();
      favorite.addEventListener('click', () => {
        const selection = favoriteSelection();
        const active = favorite.getAttribute('aria-pressed') !== 'true';
        fynchieFavoriteWrite(selection.handle, selection.color, selection.variantId, active);
        fynchieRenderFavoriteButton(favorite, active);
      });
    }

    drawer?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawer();
      if (event.key !== 'Tab' || !panel) return;
      const focusable = [...panel.querySelectorAll('button:not([disabled]):not([aria-disabled="true"]),a[href]')];
      if (!focusable.length) return;
      const first = focusable[0]; const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  });
};
initializeUniversalProducts();
document.addEventListener('shopify:section:load', (event) => initializeUniversalProducts(event.target));

const initializeProductRecommendations = (root = document) => {
  root.querySelectorAll?.('[data-product-recommendations].is-loading').forEach(async (section) => {
    if (section.dataset.recommendationsReady === 'true') return;
    section.dataset.recommendationsReady = 'true';
    try {
      const response = await fetch(section.dataset.url);
      if (!response.ok) return;
      const html = document.createElement('div');
      html.innerHTML = await response.text();
      const fresh = html.querySelector('[data-product-recommendations]');
      if (fresh?.innerHTML.trim()) section.replaceWith(fresh);
      else section.remove();
    } catch (error) { section.remove(); }
  });
};
initializeProductRecommendations();
document.addEventListener('shopify:section:load', (event) => initializeProductRecommendations(event.target));

const initializeWallpaperQuantityTools = (root = document) => {
  root.querySelectorAll?.('[data-universal-product]').forEach((productRoot) => {
    const drawer = productRoot.querySelector('[data-quantity-drawer]');
    const panel = drawer?.querySelector('.quantity-drawer__panel');
    const triggers = [...productRoot.querySelectorAll('[data-quantity-drawer-open]')];
    if (!drawer || drawer.dataset.quantityReady === 'true') return;
    drawer.dataset.quantityReady = 'true';
    let lastTrigger = null;
    const close = () => {
      drawer.classList.remove('is-open');
      triggers.forEach((item) => item.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('variant-drawer-open');
      window.setTimeout(() => { drawer.hidden = true; }, 320);
      lastTrigger?.focus({ preventScroll: true });
    };
    const open = (trigger) => {
      lastTrigger = trigger;
      drawer.hidden = false;
      document.body.classList.add('variant-drawer-open');
      triggers.forEach((item) => item.setAttribute('aria-expanded', 'true'));
      window.requestAnimationFrame(() => { drawer.classList.add('is-open'); panel?.querySelector('input,button,a')?.focus({ preventScroll: true }); });
    };
    triggers.forEach((trigger) => trigger.addEventListener('click', () => open(trigger)));
    drawer.querySelectorAll('[data-quantity-drawer-close]').forEach((button) => button.addEventListener('click', close));
    drawer.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
  });
  root.querySelectorAll?.('[data-wallpaper-calculator]').forEach((calculator) => {
    if (calculator.dataset.calculatorReady === 'true') return;
    calculator.dataset.calculatorReady = 'true';
    calculator.addEventListener('submit', (event) => {
      event.preventDefault();
      const width = Number(calculator.elements.width.value);
      const height = Number(calculator.elements.height.value);
      const rollLengthFeet = Number(calculator.elements.roll_length.value);
      const rollWidth = Number(calculator.dataset.rollWidth || 27);
      const unitLabel = calculator.dataset.unitLabel || 'roll';
      const repeat = Number(calculator.dataset.patternRepeat || 0);
      const result = calculator.querySelector('[data-result]');
      if (!width || !height || !rollLengthFeet) { result.textContent = 'Enter all three measurements for a preliminary estimate.'; return; }
      const adjustedDrop = repeat > 0 ? Math.ceil(height / repeat) * repeat : height;
      const dropsPerRoll = Math.max(1, Math.floor((rollLengthFeet * 12) / adjustedDrop));
      const requiredDrops = Math.ceil(width / rollWidth);
      const rolls = Math.max(1, Math.ceil(requiredDrops / dropsPerRoll));
      const quantityLabel = unitLabel === 'roll' ? `roll${rolls === 1 ? '' : 's'}` : `${unitLabel}${rolls === 1 ? '' : 's'}`;
      result.textContent = `Preliminary estimate: ${rolls} ${quantityLabel}. Pattern match and site conditions can change the final quantity; confirm with FYNCHIE before ordering.`;
    });
  });
};
initializeWallpaperQuantityTools();
document.addEventListener('shopify:section:load', (event) => initializeWallpaperQuantityTools(event.target));

// Rotating luxury announcement bars.
document.querySelectorAll('[data-announcement-bar]').forEach((bar) => {
  const items = [...bar.querySelectorAll('.lux-announcement__item')];
  if (items.length < 2) return;
  const autoRotate = bar.dataset.autoRotate === 'true';
  if (!autoRotate) return;
  let index = 0;
  const speed = parseInt(getComputedStyle(bar).getPropertyValue('--ann-speed'), 10) || 6000;
  window.setInterval(() => {
    items[index].classList.remove('is-active');
    index = (index + 1) % items.length;
    items[index].classList.add('is-active');
  }, speed);
});

// FYNCHIE wallpaper collection interactions and motion system.
const initializeWallpaperCollections = (root = document) => {
  root.querySelectorAll('[data-wallpaper-card]').forEach((card) => {
    if (card.dataset.wallpaperReady === 'true') return;
    card.dataset.wallpaperReady = 'true';
    const image = card.querySelector('[data-wallpaper-main-image]');
    const imageLink = card.querySelector('.wallpaper-card__image-link');
    card.querySelectorAll('[data-wallpaper-swatch]').forEach((swatch) => {
      swatch.addEventListener('click', () => {
        if (!image || !swatch.dataset.imageSrc) return;
        card.querySelectorAll('[data-wallpaper-swatch]').forEach((item) => item.classList.toggle('is-active', item === swatch));
        image.classList.add('is-changing');
        const preload = new Image();
        preload.onload = () => {
          image.src = swatch.dataset.imageSrc;
          if (swatch.dataset.imageSrcset) image.srcset = swatch.dataset.imageSrcset;
          if (imageLink && swatch.dataset.variantUrl) imageLink.href = swatch.dataset.variantUrl;
          window.requestAnimationFrame(() => image.classList.remove('is-changing'));
        };
        preload.onerror = () => image.classList.remove('is-changing');
        preload.src = swatch.dataset.imageSrc;
      });
    });
  });

  root.querySelectorAll('[data-filter-drawer]').forEach((drawer) => {
    if (drawer.dataset.drawerReady === 'true') return;
    drawer.dataset.drawerReady = 'true';
    const id = drawer.id;
    const triggers = document.querySelectorAll(`[aria-controls="${CSS.escape(id)}"]`);
    const panel = drawer.querySelector('.wallpaper-filter-drawer__panel');
    let lastTrigger = null;
    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('fynchie-overlay-open');
      const collectionRoot = drawer.closest('.wallpaper-collection, .apparel-collection');
      const durationProperty = collectionRoot?.classList.contains('apparel-collection') ? '--ac-motion-duration' : '--wc-motion-duration';
      const duration = collectionRoot ? parseInt(getComputedStyle(collectionRoot).getPropertyValue(durationProperty), 10) || 500 : 500;
      window.setTimeout(() => { drawer.hidden = true; drawer.classList.remove('is-mounted'); }, duration);
      lastTrigger?.focus({ preventScroll: true });
    };
    const openDrawer = (trigger) => {
      lastTrigger = lastTrigger || trigger;
      drawer.hidden = false;
      drawer.classList.add('is-mounted');
      document.body.classList.add('fynchie-overlay-open');
      triggers.forEach((item) => item.setAttribute('aria-expanded', 'true'));
      window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        panel?.querySelector('button, input, summary, a')?.focus({ preventScroll: true });
      }));
    };
    triggers.forEach((trigger) => trigger.addEventListener('click', () => openDrawer(trigger)));
    drawer.querySelectorAll('[data-filter-drawer-close]').forEach((button) => button.addEventListener('click', closeDrawer));
    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawer();
      if (event.key !== 'Tab' || !panel) return;
      const focusable = [...panel.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),summary,[tabindex]:not([tabindex="-1"])')];
      if (!focusable.length) return;
      const first = focusable[0]; const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  });
};
initializeWallpaperCollections();
document.addEventListener('shopify:section:load', (event) => initializeWallpaperCollections(event.target));

// Editorial apparel cards: variant imagery, selected-color favorites, and intentional hover-video playback.
const initializeApparelCollections = (root = document) => {
  root.querySelectorAll('[data-apparel-collection]').forEach((collection) => {
    if (collection.dataset.collectionReady === 'true') return;
    collection.dataset.collectionReady = 'true';
    collection.querySelectorAll('[data-apparel-view]').forEach((button) => {
      button.addEventListener('click', () => {
        const view = button.dataset.apparelView;
        collection.querySelectorAll('[data-apparel-view]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        collection.querySelectorAll('[data-apparel-main-image]').forEach((image) => {
          const src = view === 'mannequin' ? image.dataset.mannequinSrc : image.dataset.modelSrc;
          const srcset = view === 'mannequin' ? image.dataset.mannequinSrcset : image.dataset.modelSrcset;
          if (!src) return;
          image.classList.add('is-changing');
          const preload = new Image();
          preload.onload = () => {
            image.src = src;
            if (srcset) image.srcset = srcset;
            window.requestAnimationFrame(() => image.classList.remove('is-changing'));
          };
          preload.onerror = () => image.classList.remove('is-changing');
          preload.src = src;
        });
      });
    });
  });
  root.querySelectorAll('[data-apparel-card]').forEach((card) => {
    if (card.dataset.apparelReady === 'true') return;
    card.dataset.apparelReady = 'true';
    const image = card.querySelector('[data-apparel-main-image]');
    const imageLink = card.querySelector('.apparel-card__image-link');
    const titleLink = card.querySelector('.apparel-card__title');
    const video = card.querySelector('.apparel-card__video');
    const favorite = card.querySelector('[data-apparel-favorite]');
    const syncCardFavorite = () => {
      if (!favorite) return;
      fynchieRenderFavoriteButton(favorite, fynchieFavoriteRead(card.dataset.productHandle, card.dataset.cardSelectedColor || ''));
    };
    syncCardFavorite();
    favorite?.addEventListener('click', (event) => {
      event.preventDefault(); event.stopPropagation();
      const active = favorite.getAttribute('aria-pressed') !== 'true';
      fynchieFavoriteWrite(card.dataset.productHandle, card.dataset.cardSelectedColor || '', card.dataset.cardVariantId || '', active);
      fynchieRenderFavoriteButton(favorite, active);
    });
    const galleryImages = [image, ...card.querySelectorAll('[data-gallery-image]')].filter(Boolean);
    let galleryIndex = 0;
    const showGalleryImage = (nextIndex) => {
      if (galleryImages.length < 2) return;
      galleryIndex = (nextIndex + galleryImages.length) % galleryImages.length;
      card.classList.toggle('is-gallery-active', galleryIndex !== 0);
      galleryImages.forEach((item, index) => {
        item.style.opacity = index === galleryIndex ? '1' : '0';
        item.style.zIndex = index === galleryIndex ? '1' : '0';
      });
    };
    card.querySelector('[data-card-prev]')?.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); showGalleryImage(galleryIndex - 1); });
    card.querySelector('[data-card-next]')?.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); showGalleryImage(galleryIndex + 1); });
    const gallery = card.querySelector('[data-apparel-gallery]');
    let touchStartX = 0;
    gallery?.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0]?.clientX || 0; }, { passive: true });
    gallery?.addEventListener('touchend', (event) => {
      const distance = (event.changedTouches[0]?.clientX || 0) - touchStartX;
      if (Math.abs(distance) < 35) return;
      event.preventDefault();
      showGalleryImage(galleryIndex + (distance < 0 ? 1 : -1));
    });
    const quickToggle = card.querySelector('[data-quick-add-toggle]');
    const quickPanel = card.querySelector('[data-quick-add-panel]');
    quickToggle?.addEventListener('click', () => {
      const open = quickToggle.getAttribute('aria-expanded') !== 'true';
      quickToggle.setAttribute('aria-expanded', String(open));
      if (quickPanel) quickPanel.hidden = !open;
    });
    card.querySelectorAll('[data-apparel-swatch]').forEach((swatch) => {
      swatch.addEventListener('click', () => {
        if (!image || !swatch.dataset.imageSrc) return;
        card.querySelectorAll('[data-apparel-swatch]').forEach((item) => item.classList.toggle('is-active', item === swatch));
        card.dataset.cardSelectedColor = swatch.dataset.color || '';
        card.dataset.cardVariantId = swatch.dataset.variantId || '';
        if (swatch.dataset.variantUrl) {
          if (imageLink) imageLink.href = swatch.dataset.variantUrl;
          if (titleLink) titleLink.href = swatch.dataset.variantUrl;
        }
        syncCardFavorite();
        image.classList.add('is-changing');
        const preload = new Image();
        preload.onload = () => {
          image.src = swatch.dataset.imageSrc;
          if (swatch.dataset.imageSrcset) image.srcset = swatch.dataset.imageSrcset;
          window.requestAnimationFrame(() => image.classList.remove('is-changing'));
        };
        preload.onerror = () => image.classList.remove('is-changing');
        preload.src = swatch.dataset.imageSrc;
      });
    });
    if (video) {
      const play = () => video.play().catch(() => {});
      const stop = () => { video.pause(); video.currentTime = 0; };
      card.addEventListener('mouseenter', play);
      card.addEventListener('mouseleave', stop);
      card.addEventListener('focusin', play);
      card.addEventListener('focusout', stop);
    }
  });
};
initializeApparelCollections();
document.addEventListener('shopify:section:load', (event) => initializeApparelCollections(event.target));

// Generic/search product cards use the same selected-color favorite state and discreet colorway selectors.
const initializeProductCards = (root = document) => {
  root.querySelectorAll('[data-product-card]').forEach((card) => {
    if (card.dataset.productCardReady === 'true') return;
    card.dataset.productCardReady = 'true';
    const favorite = card.querySelector('[data-card-favorite]');
    const image = card.querySelector('[data-product-card-image]');
    const colorLabel = card.querySelector('[data-product-card-color]');
    const price = card.querySelector('[data-product-card-price]');
    const syncFavorite = () => fynchieRenderFavoriteButton(favorite, fynchieFavoriteRead(card.dataset.productHandle, card.dataset.cardSelectedColor || ''));
    syncFavorite();
    favorite?.addEventListener('click', (event) => {
      event.preventDefault(); event.stopPropagation();
      const active = favorite.getAttribute('aria-pressed') !== 'true';
      fynchieFavoriteWrite(card.dataset.productHandle, card.dataset.cardSelectedColor || '', card.dataset.cardVariantId || '', active);
      fynchieRenderFavoriteButton(favorite, active);
    });
    card.querySelectorAll('[data-product-card-swatch]').forEach((swatch) => {
      swatch.addEventListener('click', (event) => {
        event.preventDefault(); event.stopPropagation();
        card.querySelectorAll('[data-product-card-swatch]').forEach((item) => item.classList.toggle('is-active', item === swatch));
        card.dataset.cardSelectedColor = swatch.dataset.color || '';
        card.dataset.cardVariantId = swatch.dataset.variantId || '';
        card.querySelectorAll('[data-product-card-link]').forEach((link) => { if (swatch.dataset.variantUrl) link.href = swatch.dataset.variantUrl; });
        if (colorLabel) { colorLabel.textContent = swatch.dataset.color || ''; colorLabel.hidden = !swatch.dataset.color; }
        if (price && swatch.dataset.price) price.textContent = swatch.dataset.price;
        syncFavorite();
        if (!image || !swatch.dataset.imageSrc) return;
        const preload = new Image();
        preload.onload = () => {
          image.src = swatch.dataset.imageSrc;
          if (swatch.dataset.imageSrcset) image.srcset = swatch.dataset.imageSrcset;
        };
        preload.src = swatch.dataset.imageSrc;
      });
    });
  });
};
initializeProductCards();
document.addEventListener('shopify:section:load', (event) => initializeProductCards(event.target));

// Restrained page fade for same-origin navigation; disabled in the theme editor and for modified clicks.
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]');
  if (!link || window.Shopify?.designMode || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (link.target === '_blank' || link.hasAttribute('download')) return;
  const url = new URL(link.href, window.location.href);
  if (url.origin !== window.location.origin || url.hash && url.pathname === window.location.pathname || url.protocol !== 'http:' && url.protocol !== 'https:') return;
  event.preventDefault();
  document.body.classList.add('is-page-leaving');
  window.setTimeout(() => { window.location.href = url.href; }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220);
});
window.addEventListener('pageshow', () => document.body.classList.remove('is-page-leaving'));


// FYNCHIE premium AJAX cart drawer.
const cartDrawer = document.querySelector('[data-cart-drawer]');
const openCartDrawer = () => { if (!cartDrawer) return; cartDrawer.hidden=false; cartDrawer.setAttribute('aria-hidden','false'); document.body.classList.add('cart-open'); requestAnimationFrame(()=>cartDrawer.classList.add('is-open')); cartDrawer.querySelector('[data-cart-close]')?.focus(); };
const closeCartDrawer = () => { if (!cartDrawer) return; cartDrawer.classList.remove('is-open'); cartDrawer.setAttribute('aria-hidden','true'); document.body.classList.remove('cart-open'); setTimeout(()=>{cartDrawer.hidden=true;},500); };
const refreshCartDrawer = async () => { if (!cartDrawer) return; const [cartRes, sectionRes] = await Promise.all([fetch('/cart.js'), fetch('/?section_id=cart-drawer')]); const cart = await cartRes.json(); const html = await sectionRes.text(); const doc = new DOMParser().parseFromString(html,'text/html'); const fresh = doc.querySelector('[data-cart-drawer]'); if (fresh) { cartDrawer.querySelector('[data-cart-drawer-items]').innerHTML=fresh.querySelector('[data-cart-drawer-items]').innerHTML; cartDrawer.querySelector('[data-cart-total]').textContent=fresh.querySelector('[data-cart-total]').textContent; } document.querySelectorAll('.header-bag__count').forEach(el=>el.textContent=cart.item_count); };
document.addEventListener('submit', async (event)=>{ const form=event.target.closest('[data-ajax-cart]'); if(!form) return; event.preventDefault(); const button=form.querySelector('[name="add"]'); button?.setAttribute('aria-busy','true'); try { const response=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)}); if(!response.ok) throw new Error('Unable to add this piece.'); await refreshCartDrawer(); openCartDrawer(); announce('Added to your curation.'); } catch(error){ announce(error.message); } finally { button?.removeAttribute('aria-busy'); } });
document.addEventListener('click', async (event)=>{ if(event.target.closest('[data-cart-close]')) closeCartDrawer(); const line=event.target.closest('[data-cart-line]'); if(event.target.closest('[data-cart-remove]')&&line){ await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:line.dataset.cartLine,quantity:0})}); await refreshCartDrawer(); } const bag=event.target.closest('.header-bag'); if(bag&&cartDrawer){event.preventDefault(); await refreshCartDrawer(); openCartDrawer();} });
document.addEventListener('change', async (event)=>{ const input=event.target.closest('[data-cart-quantity]'); if(!input) return; const line=input.closest('[data-cart-line]'); await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:line.dataset.cartLine,quantity:Number(input.value)})}); await refreshCartDrawer(); });
document.addEventListener('keydown',(event)=>{if(event.key==='Escape'&&cartDrawer&&!cartDrawer.hidden) closeCartDrawer();});

// Apparel size guide drawer. Re-initializes safely in the Shopify theme editor.
const initializeSizeGuideDrawers = (scope = document) => scope.querySelectorAll('[data-universal-product]').forEach((root) => {
  const drawer = root.querySelector('[data-size-guide-drawer]');
  const panel = drawer?.querySelector('.variant-drawer__panel');
  const opener = root.querySelector('[data-size-guide-open]');
  if (!drawer || !opener || opener.dataset.sizeGuideBound === 'true') return;
  opener.dataset.sizeGuideBound = 'true';
  const close = () => {
    if (drawer.hidden) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    opener.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('variant-drawer-open');
    window.setTimeout(() => { drawer.hidden = true; }, 320);
    opener.focus({ preventScroll: true });
  };
  opener.addEventListener('click', () => {
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    opener.setAttribute('aria-expanded', 'true');
    document.body.classList.add('variant-drawer-open');
    window.requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      panel?.querySelector('[data-size-guide-close]')?.focus({ preventScroll: true });
    });
  });
  drawer.addEventListener('click', (event) => {
    if (event.target.closest('[data-size-guide-close]')) close();
  });
  drawer.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
});
initializeSizeGuideDrawers();
document.addEventListener('shopify:section:load', (event) => initializeSizeGuideDrawers(event.target));

document.querySelectorAll('[data-complete-look]').forEach((gallery) => {
  const track = gallery.querySelector('[data-complete-look-track]');
  const move = (direction) => track?.scrollBy({ left: direction * Math.max(180, track.clientWidth * .72), behavior: 'smooth' });
  gallery.querySelector('[data-complete-look-prev]')?.addEventListener('click', () => move(-1));
  gallery.querySelector('[data-complete-look-next]')?.addEventListener('click', () => move(1));
});

const initializeProductMediaGalleries = (scope = document) => scope.querySelectorAll('.product-gallery').forEach((gallery) => {
  if (gallery.dataset.mediaGalleryReady === 'true') return;
  const track = gallery.querySelector('[data-product-media-track]');
  const allItems = [...gallery.querySelectorAll('.product-gallery__item')];
  const allThumbnails = [...gallery.querySelectorAll('[data-product-media-thumbnail]')];
  const prev = gallery.querySelector('[data-product-media-prev]');
  const next = gallery.querySelector('[data-product-media-next]');
  if (!track || !allItems.length) return;
  gallery.dataset.mediaGalleryReady = 'true';

  const items = () => allItems.filter((item) => !item.hidden);
  const thumbnails = () => allThumbnails.filter((thumbnail) => !thumbnail.hidden);
  const visibleCount = () => window.matchMedia('(max-width: 749px)').matches ? 1 : 2;
  const maxIndex = () => Math.max(0, items().length - visibleCount());
  let index = 0;
  let requestedThumbnailIndex = null;

  const setActiveThumbnail = (activeIndex) => {
    thumbnails().forEach((thumbnail, thumbnailIndex) => {
      const isActive = thumbnailIndex === activeIndex;
      thumbnail.classList.toggle('is-active', isActive);
      thumbnail.setAttribute('aria-current', String(isActive));
    });
    thumbnails()[activeIndex]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  };

  const syncIndexFromScroll = () => {
    if (requestedThumbnailIndex !== null) return;
    if (!items()[0]) return;
    const step = Math.max(1, items()[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0));
    index = Math.min(maxIndex(), Math.max(0, Math.round(track.scrollLeft / step)));
    setActiveThumbnail(index);
  };

  const goTo = (nextIndex, behavior = 'smooth') => {
    const max = maxIndex();
    index = nextIndex < 0 ? max : nextIndex > max ? 0 : nextIndex;
    const target = items()[index];
    if (!target) return;
    setActiveThumbnail(index);
    track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior });
  };

  const goToThumbnail = (nextIndex) => {
    const thumbnailIndex = Math.min(items().length - 1, Math.max(0, nextIndex));
    const target = items()[thumbnailIndex];
    if (!target) return;
    requestedThumbnailIndex = thumbnailIndex;
    index = Math.min(thumbnailIndex, maxIndex());
    setActiveThumbnail(thumbnailIndex);
    const targetLeft = Math.min(target.offsetLeft - track.offsetLeft, Math.max(0, track.scrollWidth - track.clientWidth));
    track.scrollTo({ left: targetLeft, behavior: 'smooth' });
    window.setTimeout(() => {
      setActiveThumbnail(thumbnailIndex);
      requestedThumbnailIndex = null;
    }, 500);
  };

  prev?.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); goTo(index - 1); });
  next?.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); goTo(index + 1); });
  allThumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    goToThumbnail(Number(thumbnail.dataset.mediaIndex || 0));
  }));
  track.addEventListener('scroll', () => window.requestAnimationFrame(syncIndexFromScroll), { passive: true });
  window.addEventListener('resize', () => goTo(Math.min(index, maxIndex()), 'auto'));

  gallery.fynchieSelectColor = (colorLabel, featuredMediaId) => {
    const normalizedColor = String(colorLabel || '').toLowerCase();
    allItems.forEach((item) => {
      const alt = item.dataset.mediaAlt || '';
      const isColorTagged = alt.includes('[color:');
      item.hidden = isColorTagged && !alt.includes(`[color: ${normalizedColor}]`) && String(item.dataset.mediaId) !== String(featuredMediaId || '');
    });
    allThumbnails.forEach((thumbnail) => {
      const matchingItem = allItems.find((item) => String(item.dataset.mediaId) === String(thumbnail.dataset.mediaId));
      thumbnail.hidden = Boolean(matchingItem?.hidden);
    });
    index = 0;
    goTo(0, 'auto');
    if (prev) prev.hidden = items().length <= visibleCount();
    if (next) next.hidden = items().length <= visibleCount();
  };

  const productRoot = gallery.closest('[data-universal-product]');
  const selectedColorway = productRoot?.querySelector('[data-product-colorway].is-current');
  if (selectedColorway) {
    let selectedVariant;
    try {
      const variants = JSON.parse(productRoot.querySelector('[data-product-variants-json]')?.textContent || '[]');
      selectedVariant = variants.find((variant) => String(variant.id) === String(productRoot.querySelector('[data-variant-input]')?.value || selectedColorway.dataset.variantId));
    } catch (error) { selectedVariant = null; }
    gallery.fynchieSelectColor(selectedColorway.dataset.colorLabel, selectedVariant?.featured_media?.id);
  }

  const showControls = items().length > visibleCount();
  if (prev) prev.hidden = !showControls;
  if (next) next.hidden = !showControls;
});
initializeProductMediaGalleries();
document.addEventListener('shopify:section:load', (event) => initializeProductMediaGalleries(event.target));

// When Shopify's Color filter is active, keep only the separately rendered
// colorway cards that match it. Other Search & Discovery filters remain native.
const activeCollectionColors = [...new URLSearchParams(window.location.search).entries()]
  .filter(([key]) => /filter\.v\.option\.(color|colour)$/i.test(key))
  .map(([, value]) => value.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''));
if (activeCollectionColors.length) {
  document.querySelectorAll('[data-card-color]').forEach((card) => {
    card.hidden = !activeCollectionColors.includes(card.dataset.cardColor);
  });
}
